import React, {useState} from "react";
import {Box, createTheme, CssBaseline, Table, ThemeProvider,} from "@mui/material";

const ReportScreen = () => {
    const [darkMode, setDarkMode] = useState(true);

    const theme = createTheme({
        palette: {
            mode: darkMode ? "dark" : "light",
        },
    });


    return (
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <Box sx={{mx: "auto", p: 2}}>
                <Table></Table>
            </Box>
        </ThemeProvider>
    );
};

export default ReportScreen;
